module.exports = __webpack_public_path__ + "img/Angiogenesis-OPSCC_PMID37704757.8c137d60.png";